import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Laczy klasy Tailwinda rozwiazujac konflikty — pozniejsza klasa wygrywa
 * niezaleznie od kolejnosci w arkuszu. Uzywaj wszedzie, gdzie komponent
 * przyjmuje `className` od rodzica.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
